package it.unibo.tuprolog.parser.tokens

/** Delimiter family of a decoded quoted token payload. */
enum class QuoteKind {
    SINGLE,
    DOUBLE,
}
